import React, { Component, Fragment } from "react";

import Calendar from "./Calendar";
import FullScreenLoader from "./FullScreenLoader";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getSchedule } from "../actions/employeeActions";
import { getScheduleOfCompanyEmployee } from "../actions/companyEmployeeActions";

import FormErrorMessage from "../components/forms/FormErrorMessage";
import moment from "moment";

let credentials = JSON.parse(localStorage.getItem("credentials"));

class ScheduleOfEmployee extends Component {
  state = {
    events: [],
  };

  componentDidMount() {
    if (this.props.companyEmail && !credentials.user.isAdmin) {
      this.props
        .getScheduleOfCompanyEmployee(
          this.props.companyEmail,
          this.props.employeeEmail,
        )
        .then((schedule) => {
          this.setState({
            events: schedule.map((s) => {
              return {
                id: s.id,
                title: s.project.name,
                start: moment(
                  s.employees[0].CompanyEmployeeShift.startDateTime ||
                    s.beginDatetime,
                ).toDate(),
                end: moment(
                  s.employees[0].CompanyEmployeeShift.endDateTime ||
                    s.endDatetime,
                ).toDate(),
                desc: `${s.project.street} ${s.project.streetNumber}, ${s.project.zipcode} ${s.project.city}`,
              };
            }),
          });
        });
    } else {
      this.props.getSchedule(this.props.employeeEmail).then((schedule) => {
        this.setState({
          events: schedule.map((s) => {
            return {
              id: s.id,
              title: s.project.name,
              start: moment(
                s.employees[0].CompanyEmployeeShift.startDateTime ||
                  s.beginDatetime,
              ).toDate(),
              end: moment(
                s.employees[0].CompanyEmployeeShift.endDateTime ||
                  s.endDatetime,
              ).toDate(),
              desc: `${s.project.street} ${s.project.streetNumber}, ${s.project.zipcode} ${s.project.city}`,
            };
          }),
        });
      });
    }
  }

  render() {
    return (
      <Fragment>
        <Calendar
          events={this.state.events}
          onSelectEvent={(s) =>
            (window.location.href = `/shift/active/${s.id}`)
          }
        />

        {this.props.isFetching && <FullScreenLoader />}

        {this.props.errorMessage && (
          <FormErrorMessage errorMessage={this.props.errorMessage} />
        )}
      </Fragment>
    );
  }
}

ScheduleOfEmployee.propTypes = {
  companyEmail: PropTypes.string,
  employeeEmail: PropTypes.string.isRequired,
  getSchedule: PropTypes.func.isRequired,
  getScheduleOfCompanyEmployee: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = (state) => ({
  isFetching:
    state.employee.getSchedule.isFetching ||
    state.companyEmployee.getScheduleOfCompanyEmployee.isFetching,
  errorMessage:
    state.employee.getSchedule.errorMessage ||
    state.companyEmployee.getScheduleOfCompanyEmployee.errorMessage,
});

export default connect(mapStateToProps, {
  getSchedule,
  getScheduleOfCompanyEmployee,
})(ScheduleOfEmployee);



// WEBPACK FOOTER //
// ./src/components/ScheduleOfEmployee.js